<!-- modal import -->
<div class="modal fade" id="{{idmodal}}" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">{{title}} - Import</h4>
      </div>
      <div class="modal-body">
        <div class="container">

          <form>
            <!-- COMPONENT START -->
            <div class="form-group">
              <label class="control-label">File upload </label>
              <input type="file" class="filestyle" (change)="uploadFile($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" data-buttonText="Select a File">
            </div>
            <!-- COMPONENT END -->
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-color2 btn-right" data-dismiss="modal">Close</button>
          <button type="button" id="buttonSubmitUpload" (click)="saveFile()" data-dismiss="modal" class="btn btn-color2 btn-right" >Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- modal import end -->
